// ** React Imports
import React from "react";

// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledTableHeaderCell = styled(
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	({
		hidden,
		min,
		max,
		maxWidthPercent,
		center,
		isMain,
		minWidth,
		...props
	}) => React.createElement("th", props)
).attrs({
	scope: "col",
})`
	padding: 0.75rem;

	vertical-align: bottom;
	font-weight: bold;
	${({ hidden }) =>
		hidden &&
		css`
			display: none;
		`}
	${({ min }) =>
		min &&
		css`
			width: 1%;
		`}
	${({ minWidth }) =>
		minWidth &&
		css`
			min-width: ${minWidth};
		`}
		${({ maxWidthPercent }) =>
		maxWidthPercent &&
		css`
			width: ${maxWidthPercent}%;
		`}
	${({ max }) =>
		max &&
		css`
			width: 100%;
		`}
	${({ center }) =>
		center &&
		css`
			text-align: center;
		`}

	${({ lowerCheckPadding }) =>
		lowerCheckPadding &&
		css`
			padding-left: 0.25rem;
		`}
`;

// #####################################################
